import Discovery from "..";

export { getServerSideProps } from "..";

export default Discovery;
